import PropTypes from 'prop-types';

import { LumberDeckingProvider } from './LumberDeckingContext';
import LumberDeckingForm from './LumberDeckingForm';
import LumberDeckingSheet from './LumberDeckingSheet';
import { Container } from './styles';

export const LumberDeckingCalculator = ({ copy }) => (
  <LumberDeckingProvider>
    <Container>
      <LumberDeckingForm copy={copy} />
      <LumberDeckingSheet />
    </Container>
  </LumberDeckingProvider>
);

LumberDeckingCalculator.propTypes = {
  copy: PropTypes.shape({
    title: PropTypes.string,
    subtitle: PropTypes.string,
    description: PropTypes.string,
    disclaimer: PropTypes.string,
  }).isRequired,
};
